export default __webpack_public_path__ + "static/media/ig4.f49cbbbc.jpg";